import { useCardDismissal } from 'hooks/queries/cardDismissals/useCardDismissal'
import { BottomItems } from '../BottomItems/BottomItems'
import { ReferralBannerCTA } from '../ReferralBannerCTA/ReferralBannerCTA'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const MobileBottomItems = () => {
  const { data, isLoading } = useCardDismissal('left_rail_referral_cta')
  const isAPMobileWeb = useAPMobileWeb()

  if (isLoading) {
    return null
  }

  if (data?.is_dismissed || isAPMobileWeb) {
    return <BottomItems />
  }

  return <ReferralBannerCTA />
}
